/** @format */

import PingLeaf from "./PingLeaf"

export default PingLeaf
